// extracted by mini-css-extract-plugin
module.exports = {"selectedTab":"MapLayerDatasetPlugin_selectedTab__1d3WX","tab":"MapLayerDatasetPlugin_tab__paW2H","tabList":"MapLayerDatasetPlugin_tabList__2OGeK"};